import { render, staticRenderFns } from "./rank-rule.vue?vue&type=template&id=4baec704"
import script from "./rank-rule.vue?vue&type=script&lang=js"
export * from "./rank-rule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports